import { isFinalParentSignUpFormRequired } from 'main/components/common/AuthModal/parent/FinalParentSignUpForm'
import { isIntermediateParentSignUpFormRequired } from 'main/components/common/AuthModal/parent/IntermediateParentSignUpForm'
import { User_user } from 'main/gql/user'
import { Step } from './types'

export function authModalInitialStep(user: User_user | null) {
  if (!user) return Step.ParentStart
  if (isIntermediateParentSignUpFormRequired(user)) return Step.ParentIntermediate
  if (isFinalParentSignUpFormRequired(user)) return Step.ParentFinal
  return null
}

export function isModalRequired(user: User_user | null) {
  return !!authModalInitialStep(user)
}
